export const SET_CERTFOCUS_FETCHING_HIRING_CLIENT = 'SET_CERTFOCUS_FETCHING_HIRING_CLIENT';
export const SET_CERTFOCUS_HIRING_CLIENT_SUCCESS = 'SET_CERTFOCUS_HIRING_CLIENT_SUCCESS';
export const SET_CERTFOCUS_HIRING_CLIENT_SELECTED = 'SET_CERTFOCUS_HIRING_CLIENT_SELECTED';
export const SET_CERTFOCUS_FORMS_SUCCESS = 'SET_CERTFOCUS_FORMS_SUCCESS';
export const SET_CERTFOCUS_SUBMISSIONS_FORMS_SUCCESS = 'SET_CERTFOCUS_SUBMISSIONS_FORMS_SUCCESS';
export const SET_CERTFOCUS_FETCHING_TABLE = 'SET_CERTFOCUS_FETCHING_TABLE';
export const SET_CERTFOCUS_CLEAR_FORM_SUBMISSION = 'SET_CERTFOCUS_CLEAR_FORM_SUBMISSION';
export const SET_CERTFOCUS_SUBCONTRACTOR_SELECTED = 'SET_CERTFOCUS_SUBCONTRACTOR_SELECTED';
export const SET_CERTFOCUS_COPY_SUBMISSION_SUCCESS = 'SET_CERTFOCUS_COPY_SUBMISSION_SUCCESS';
